<template>
  <div class="core requestForm">
    <div class="layui-layer-title" style="cursor: move;">{{ title }}</div>
    <div class="layui-layer-content">
      <div class="layui-layer-wrap">
        <div class="form-collapse">
          <div class="info">
            <layui-form
              ref="repairApproveFormRef"
              :rule="repairApproveFormRule"
              :show-form="true"
              :after-save="handleAfterSave"
              requestUniqueId="repairRequestID"
            >
              <template slot-scope="{ scope }">
                <div class="layui-form">
                  <layui-collapse ref="collapse" class>
                    <div class="layui-colla-item">
                      <div class="layui-colla-item">
                        <h2 class="layui-colla-title">报修信息</h2>
                        <div class="layui-colla-content layui-show">
                          <div class="layui-form-item-two">
                            <div class="layui-form-item-left" style="width: 55%">
                              <div class="layui-form-item">
                                <label class="layui-form-label">报修编号：</label>
                                <label class="layui-form-label right textarea">{{ formData.REPAIR_BILL_CODE }}</label>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">报修单名称：</label>
                                <label class="layui-form-label right textarea">{{
                                  formData.REPAIR_BILL_EXT_NAME
                                }}</label>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">报修分类：</label>
                                <label class="layui-form-label right">{{ formData.REPAIR_TYPE_EXT_NAME }}</label>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">联系人：</label>
                                <label class="layui-form-label right">{{ formData.TEMP_CONTACT_PSN_EXT_NAME }}</label>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">联系电话：</label>
                                <label class="layui-form-label right">{{ formData.TEMP_CONTACT_PSN_PHONE }}</label>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">问题描述：</label>
                                <label class="layui-form-label right">{{ formData.PROBLEM_DESCRIPTION }}</label>
                              </div>
                              <div class="layui-form-bottom">
                                <label class="layui-form-label">附件：</label>
                                <div class="layui-input-inline" style="width:100%; padding-left: 140px">
                                  <layui-listfileupload v-model="formData.FILE_IDS" :enabled="false" targetEl=".requestForm">
                                  </layui-listfileupload>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="layui-colla-item">
                      <div class="layui-colla-item">
                        <h2 class="layui-colla-title">门店信息</h2>
                        <div class="layui-colla-content layui-show">
                          <div class="layui-form-item-two">
                            <div class="layui-form-item-left" style="width: 55%">
                              <div class="layui-form-item">
                                <label class="layui-form-label">品牌名称：</label>
                                <label class="layui-form-label right textarea">{{ formData.BRAND_NAME }}</label>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">门店名称：</label>
                                <label class="layui-form-label right">{{ formData.STORE_NAME }}</label>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">店长名称：</label>
                                <label class="layui-form-label right">{{ formData.STORE_MANAGER }}</label>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">联系电话：</label>
                                <label class="layui-form-label right">{{ formData.STORE_MANAGER_PHONE }}</label>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">门店地址：</label>
                                <label class="layui-form-label right">{{ formData.ADDRESS }}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="layui-colla-item">
                      <div class="layui-colla-item">
                        <h2 class="layui-colla-title">审核信息</h2>
                        <div class="layui-colla-content layui-show">
                          <div class="layui-form-item-one">
                            <div class="layui-form-item">
                              <label class="layui-form-label"><span class="x-red">*</span>审核：</label>
                              <div class="layui-input-inline" style="width: 32%;">
                                <layui-radio
                                  v-model="config.form.CUSTOM_SERVICE_APPROVE_STATUS_ID"
                                  name="CUSTOM_SERVICE_APPROVE_STATUS_ID"
                                >
                                  <option value="8" title="通过"></option>
                                  <option value="5" title="不通过"></option>
                                </layui-radio>
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">审核意见：</label>
                              <div class="layui-input-inline" style="width:32%">
                                <textarea
                                  v-model="config.form.APPROVE_OPINION"
                                  placeholder="请输入审核意见"
                                  name="APPROVE_OPINION"
                                  class="layui-textarea"
                                >
                                </textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </layui-collapse>
                </div>
                <div class="layui-form-btn">
                  <div class="layui-footer">
                    <button class="layui-btn refresh" title="关闭" @click="onCancelBtn()">关 闭</button>
                    <button class="layui-btn" title="保存" @click="onSaveBtn()">保 存</button>
                  </div>
                </div>
              </template>
            </layui-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      requestId: 'repairApproveFormRequest',
      repairApproveFormRule: {
        CUSTOM_SERVICE_APPROVE_STATUS_ID: {
          required: { message: '请选择审核结果' }
        }
      },
      config: { form: {} },
      formData: {},
      title: ''
    }
  },

  mounted() {
    if (this.tabParam) {
      this.formData = this.tabParam.editRow
      this.tableObj = this.tabParam.tableObj
      this.config.form = this.tabParam.editRow
      this.formType = this.tabParam.formType
      this.title = this.tabParam.title

      this.formData.APPROVE_OPINION = ''
      this.formData.CUSTOM_SERVICE_APPROVE_STATUS_ID = ''
    }
  },

  methods: {
    handleAfterSave() {
      this.baseComponent.loadComponentByName('repairManage')

      this.layer.openSuccess('保存成功!')
      if (this.tableObj) {
        this.tableObj.pageInfo.pageIndex = 1
        this.tableObj.load()
      }
    },

    onCancelBtn() {
      // this.baseComponent.loadComponentByName('repairManage')
      this.baseComponent.closeComponent(this.tabParam.cloneMenu);
    },

    onSaveBtn() {
      if (this.config.form.CUSTOM_SERVICE_APPROVE_STATUS_ID == 8) {
        this.config.form.CUSTOM_SERVICE_APPROVE_STATUS_NAME = '客服审核通过'
      } else {
        this.config.form.CUSTOM_SERVICE_APPROVE_STATUS_NAME = '客服审核不通过'
      }
      this.$refs.repairApproveFormRef.editRow = this.config.form
      this.$refs.repairApproveFormRef.requestUniqueId = this.requestId
      this.$refs.repairApproveFormRef.callableSave('YW_REPAIRS')

      // return request({
      //   url: '/yw/repairManage/saveRepairApproveData/',
      //   method: 'post',
      //   data: JSON.stringify(this.config.form)
      // });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/repairs/repairManage/repairMngForm.vue